module.exports = __webpack_public_path__ + "img/43_35.896792a9.png";